// extracted by mini-css-extract-plugin
export default {"text":"HintOpenStreetRacerFolder_text__Xbg6S"};